import formatNumber from './formatNumber';

export default formatNumber;
